import { DangerZone } from '../danger-zone';
// import { ExportSection } from '../export-section';
import { ProfileSection } from '../profile-section';

export function AccountPanel() {
  return (
    <div className="flex flex-col gap-4" data-testid="settings-panel-account">
      <ProfileSection />
      {/* GDPR self-export — disabled per product request; re-enable by
          uncommenting the import above and the element below.
          <ExportSection /> */}
      <DangerZone />
    </div>
  );
}
